module.exports = {
	"fr": {
		"translation": {
			"moreInformation": "plus d'informations",
			"close": "Fermer",
			"uploader": {
				"overlay": {
					"title": "Glisser-déposer",
					"subtitle": "Vos fichiers ici"
				},
				"form": {
					"dragAndDrop": "Glisser-déposer",
					"or": "ou",
					"chooseFiles": "Sélectionner des fichiers",
					"from": "Depuis votre ordinateur"
				},
				"errors": {
					"file_size": "dépasse la taille du fichier {{size}} maximale.",
					"file_type": "{{type}} est un type de fichier incorrect."
				},
				"status": {
					"idle": "inactif",
					"processing": "traitement",
					"uploading": "chargement",
					"success": "réussite",
					"cancel": "annuler",
					"error": "erreur",
					"none": ""
				}
			},
			"actions": {
				"delete": "Supprimer",
				"apply": "Appliquer",
				"cancel": "Annuler"
			},
			"dateInput": {
				"choose": "Choisir une date",
				"clear": "Effacer la date"
			},
			"daterange": {
				"last_7_days": "7 derniers jours",
				"last_30_days": "30 derniers jours",
				"this_month": "Ce mois",
				"last_month": "Le mois dernier",
				"start_date": "Date de début",
				"end_date": "Date de fin",
				"not_set": "Non défini"
			},
			"comment": {
				"delete": "Supprimer le commentaire"
			},
			"pagination": {
				"intro": "Pagination, actuellement à la page {{currentPage}}",
				"page": "Page {{pageNumber}}",
				"ellipsis": "Plus de pages",
				"prev": "Page précédente",
				"next": "Page suivante"
			},
			"formElement": {
				"optional": "(facultatif)",
				"required": "(requis)"
			},
			"prevNextArrowButton": {
				"arrowup": "haut",
				"arrowdown": "bas",
				"escape": "Échap"
			},
			"externalLink": {
				"view": "voir"
			},
			"collapsible": {
				"ariaText": "section compressible"
			}
		}
	}
};